import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { ICourseMaster } from "../../../Pages/CourseMaster/ICourseMaster";

export const ListCourseMasterSlice = createSlice({
  name: "ListCourseMasterSlice",
  initialState: {} as IReduxState<ICourseMaster[]>,
  reducers: {
    listCourseMaster: (state) => {
      state.isLoading = true;
    },
    getCourseMasterById: (state, _action) => {
      state.isLoading = true;
    },
    successlistCourseMaster: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurelistCourseMaster: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const { failurelistCourseMaster, listCourseMaster, getCourseMasterById, successlistCourseMaster } =
  ListCourseMasterSlice.actions;

export default ListCourseMasterSlice.reducer;
